import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
const useStyles = makeStyles(theme => ({
  dialog: {
    "& .MuiDialog-paper": {
      margin: 20,
    },
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    top: 0,
    right: 0,
  },
}))
const Modal = ({ children, open, onClose, maxWidth, fullWidth }) => {
  const classes = useStyles()
  return (
    <Dialog
      open={open}
      className={classes.dialog}
      onClose={onClose}
      maxWidth={maxWidth ? "xs" : "sm"}
      fullWidth={fullWidth ? fullWidth : false}
    >
      <IconButton onClick={onClose} className={classes.closeButton}>
        <CloseIcon />
      </IconButton>
      <div>{children && <DialogContent>{children}</DialogContent>}</div>
    </Dialog>
  )
}

export default Modal
